<div class="panel">
    <div class="panel-header">
        <div class="panel-title"><h2>About F&I Forms</h2></div>
        <p>
            F&I Forms is a library of forms and documents that can be included in Deal Jackets. For your convenience, the library is pre-populated with a set of system documents that are standard across the application and cannot be modified or deleted. The e-sign consent forms for the buyer and co-buyer are required for every Deal Jacket; the others are optional. 
        </p>
    </div>

    <div class="panel-body">
        <p>
            In addition to these system documents, you can add forms and documents that are regularly used in Deal Jackets at your dealership, including forms that only dealer users will see. There is no limit to the number and type of forms you can add to the library; however, we recommend limiting the documents here to those that are used fairly frequently, for multiple deal types, and/or by multiple people. Documents that are rarely or less frequently needed can be added directly to any Deal Jacket by clicking the Upload Documents button. 
        </p>

        <p>
            <b>NOTE:</b> Adding documents that involve printing data from your DMS or other systems requires an enhanced service package. Contact us at {{supportEmail}} or {{tenantSupportPhone}} to learn more. 
        </p>

        <h3>Creating and Managing F&I Forms</h3>
        
        <p>
            To add an F&I form or document, click the Create F&I Form button and complete each section. Every form must have a name and description. Next you will select the type of form, upload a template of the form as needed and then add signatures, initials and other fields. Finally, you will indicate who will add the form or document to a Deal Jacket. To modify an existing form, select it from the list and then make the necessary changes. You can also delete forms no longer in use. Watch the video for a step-by-step demonstration of these processes. 
        </p>
    </div>
    
    <!-- <div  class="video-section">
        <div (click)="openVideo('E-SHOP Leads', 'E-SHOPLeadsOverview.mp4')" class="image-wrap">
          
            <div class="image-overlay">
                <mat-icon class="play-icon">play_circle_outline</mat-icon>
            </div>
            <video [src]="this.envVideoUrl + 'E-SHOPLeadsOverview.mp4' + '#t=4.8' "></video>
        </div>
        <div class="video-text">
            <h3>E-SHOP Leads</h3>
    
            <p>
               {{isReadMore ? fullDesc : shortDesc}}   <button *ngIf="fullDesc.length >= 200" class="read-more-btn" (click)="readMore()">
                {{ isReadMore ? 'Read Less' : 'Read More...' }}
            </button>
            </p>
    
            <button (click)="openVideo('E-SHOP Leads', 'E-SHOPLeadsOverview.mp4')" class="extension-btn">See Video</button>
        </div>
    </div> -->
    
    <div class="panel-body">
    
        <h3>Click the dropdown arrows below for tips and guidance on creating and managing F&I forms.</h3>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h4 class="drop-header">Form Information</h4>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="no-margin-top">
                Both the name and description are required and will be viewable by customers, so be sure it is easy for anyone to recognize the form and its purpose. Since many customers may use their mobile devices to access forms, keep both the name and description as short as possible. 
            </p>
           
        </mat-expansion-panel>
        <div class="underline"></div>
    
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h4 class="drop-header">Form Type</h4>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="no-margin-top">
                There are two main form types that can be used with the core product: those that are ready for signatures and those that are manually uploaded during the deal. Dealerships with the enhanced service package also have access to two form types that enable data to be printed from your DMS or other systems. The When to Use on-screen guidance provides more details on each of these form types. 
            </p>
        </mat-expansion-panel>
        <div class="underline"></div>
       
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h4 class="drop-header">Forms Added to Deal Jackets</h4>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="no-margin-top">
                Forms and documents can be added to Deal Jackets by dealer users, buyers or co-buyers. If you need a document to be uploaded by both a buyer and a co-buyer, create a version of the document for each. Forms that require signatures, initials, etc. can only be added by dealer users. Click the checkbox at the bottom of the screen if the form is one that will only be seen by the dealer. 
            </p>
        </mat-expansion-panel>
        <div class="underline"></div>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h4 class="drop-header">Creating and Editing Form Templates</h4>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="no-margin-top">
                All forms and documents except those manually uploaded during a deal will be used to capture signatures and more when a deal is being finalized. Once the PDF of the form has been uploaded for a new F&I form, it will open in a separate screen for editing. For existing forms, click Edit at the top of the rendered form template on this screen to access the editing screen. See the Learn More pop-out help panel on the Edit Document screen for additional details and guidance on creating and editing form templates. 
            </p>
        </mat-expansion-panel>
        <div class="underline"></div>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h4 class="drop-header">Modifying and Deleting Existing Forms</h4>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="no-margin-top">
                Changes to existing forms will not impact any existing Deal Jackets that include the form. They will only be applied to Deal Jackets created after the form has been updated. Deleting a form will not remove it from any existing Deal Jackets. 
            </p>
        </mat-expansion-panel>
        <div class="underline"></div>

        <div style="margin-top: 20px;" class="highlight">Pro tip: Periodically review the list of forms in your document library and add new forms, update existing forms and delete forms no longer in use.</div>
    </div>
    </div>